export default "__VITE_ASSET__BOgfer78__"